import Vue from "vue";
import VueRouter from "vue-router";
import goTo from "vuetify/es5/services/goto";
import Home from "../views/Home";
import AuthenticateUser from "../components/AuthenticateUser";
import FrmRandomisation from "../components/FrmRandomisation";
import FrmRandOutcome from "../components/FrmRandOutcome";
import FrmSettings from "../components/FrmSettings";
import FrmSyncData from "../components/FrmSyncData";
import FrmPostRand from "../components/FrmPostRandCRF";

Vue.use(VueRouter);

const routes = [
  {
    path: "/home",
    name: "Home",
    component: Home,
  },
  {
    path: "/",
    name: "randomise-participant",
    component: FrmRandomisation,
    meta: { activeUser: true },
  },
  {
    path: "/rand-outcome",
    name: "rand-outcome",
    component: FrmRandOutcome,
    meta: { activeUser: true },
    props: true,
  },
  {
    path: "/post-rand",
    name: "post-rand",
    component: FrmPostRand,
    meta: { activeUser: true },
    props: true,
  },
  {
    path: "/sync-data",
    name: "sync-data",
    component: FrmSyncData,
    meta: { activeUser: true },
  },
  {
    path: "/settings",
    name: "settings",
    component: FrmSettings,
    meta: { activeUser: true },
  },
  {
    path: "/activate-profile",
    name: "activate-profile",
    component: AuthenticateUser,
  },
];
const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior: () => {
    /* const scrollTo = { target: ".app-main", offset: 0 };
    if (to.hash) {
      scrollTo.target = to.hash;
    } else if (savedPosition) {
      scrollTo.target = savedPosition.y;
    }
    if (to.path == "/") { */
    return goTo(0);
    // } else {
    //   return goTo(scrollTo.target, { offset: scrollTo.offset });
    // }
  },
});

export default router;
